import React, { useState } from 'react';
import useFetchData from '../GetJobs';
export const Context = React.createContext();



const Provider = props => {
    const [jobDetail, setJobDetail] = useState({}); //single job detail object
    const [jobParams, setJobParams] = useState(0); //job params for search
    const {data, loading} = useFetchData(jobParams); 
    const [pageIndex, setPageIndex] = useState(1);  //sets the page num that the user is on


    return (
      <Context.Provider
        value={{
          data,
          loading,
          jobDetail,
          jobParams,
          pageIndex,
          updateJobParams: jobParams => setJobParams(jobParams),
          updateJobDetail: jobDetail => setJobDetail(jobDetail),
          updatePageIndex: pageIndex => setPageIndex(pageIndex)
        }}
      >
        {props.children}
      </Context.Provider>
    );
  };
  
  export default Provider;
